<template>
    <pm-simple-component-layout :toolbar-back="toolbarBack">
        <template slot="title">
            Terms &amp; Conditions
        </template>
        <pm-tos-android v-if="!isIOS" />
        <pm-tos-ios v-if="isIOS" />
    </pm-simple-component-layout>
</template>

<script>
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";
import PmTosIos from "./tos-ios";
import PmTosAndroid from "./tos-android";
export default {
    name: "TermsAndConditions",

    components: {
        PmSimpleComponentLayout,
        PmTosIos,
        PmTosAndroid
    },

    data: () => {
        return ({
            prevRoute: '/',
        });
    },

    computed: {
        isIOS() {
            return !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
        },
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    methods: {
        toolbarBack() {
            this.$router.push(this.prevRoute);
        },
    }
};
</script>
